import { useApi } from '@/composables/use-api'
import {
  IThreadMessagesResponse,
  ISendMessageResponse,
  IRetryMessageResponse,
  TEventsResponse,
  TThreadMessagesParams,
  TSendMessageParams,
  TRetryMessageParams,
  TEventsParams,
  IExportThreadResponse,
  TExportThreadParams,
} from './types'

export const MessagesApi = {
  getThreadMessages({ thread_id, before_id, limit = 30 }: TThreadMessagesParams) {
    const params = new URLSearchParams({
      limit: limit.toString(),
    })

    if (before_id) params.append('before_id', before_id)

    const url = `/threads/${thread_id}/messages?${params.toString()}`
    return useApi().get<IThreadMessagesResponse>(url)
  },

  retrySendMessage(message_id: string) {
    const url = `/messages/${message_id}/retry`
    return useApi().post(url)
  },

  sendMessage({ thread_id, data }: TSendMessageParams) {
    const url = `/threads/${thread_id}/messages`
    return useApi().post<ISendMessageResponse>(url, data)
  },

  updateThread(thread_id: string, title: string) {
    const url = `/threads/${thread_id}`
    return useApi().patch(url, { title })
  },

  deleteThread(thread_id: string) {
    const url = `/threads/${thread_id}`
    return useApi().delete(url)
  },

  exportThread({ thread_id, export_format }: TExportThreadParams) {
    const url = `/threads/${thread_id}/export`
    const params = new URLSearchParams()

    if (export_format) {
      params.append('export_format', export_format)
    }

    return useApi().get<IExportThreadResponse>(`${url}?${params.toString()}`)
  },

  retryMessage({ message_id }: TRetryMessageParams) {
    const url = `/messages/${message_id}/retry`
    return useApi().post<IRetryMessageResponse>(url)
  },

  subscribeEvents({ thread_id, client_id }: TEventsParams) {
    const params = new URLSearchParams({
      thread_id,
    })

    if (client_id) params.append('client_id', client_id)

    const url = `/events?${params.toString()}`
    return useApi().get<TEventsResponse>(url)
  },
}
